import { http } from "@/http/axios.js";
import axios from "axios";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { showScreenLoading, hideScreenLoading } from "@/http/loading.js";
import { Message } from "element-ui";
import { dateFormat } from "@/utils/index.js";
// list
export function getListAPI(params) {
  return http({
    url: "/admin/store/page",
    method: "get",
    params,
  });
}
// delete
export function deleteStoreAPI(id) {
  return http({
    url: "/admin/store/delete",
    method: "post",
    data: { id },
  });
}
// 申请开通支付宝子商户
export function applyAlipaySubMerchantAPI(id) {
  return http({
    url: "/admin/store/alipaySubMerchant/apply",
    method: "post",
    data: { id },
  });
}
// add
export function addStoreAPI(data) {
  return http({
    url: "/admin/store/add",
    method: "post",
    data,
  });
}
// edit
export function editStoreAPI(data) {
  return http({
    url: "/admin/store/edit",
    method: "post",
    data,
  });
}
// detail
export function getStoreDetailAPI(id) {
  return http({
    url: "/admin/store/detail",
    method: "get",
    params: { id },
  });
}
// detail
export function getStoreEditDetailAPI(id) {
  return http({
    url: "/admin/store/edit/detail",
    method: "get",
    params: { id },
  });
}
// status
export function changeStatusAPI(data) {
  return http({
    url: "/admin/store/status",
    method: "post",
    data,
  });
}
export function changeEnableLoginAPI(data) {
  return http({
    url: "/admin/store/loginStatus",
    method: "post",
    data,
  });
}

// 更改区域跟进人是否可配置
export function editAreaFollowStatusAPI(data) {
  return http({
    url: "/admin/store/editAreaFollowStatus",
    method: "post",
    data,
  });
}
// status
export function changeWapStatusAPI(data) {
  return http({
    url: "/admin/store/wap",
    method: "post",
    data,
  });
}
// 二维码
export function getQrcodeAPI(id) {
  return http({
    url: "/admin/store/qrImage",
    method: "post",
    data: { id },
  });
}
// 物料
export function getStoreMaterialAPI(id) {
  return http({
    url: "/admin/store/materialImage",
    method: "post",
    data: { id },
  });
}
// 支付宝物料
export function getStoreAlipayMaterialAPI(id) {
  return http({
    url: "/admin/store/alipayMaterialImage",
    method: "post",
    data: { id },
  });
}
// 方案计算器链接
export function getStoreComboLinkAPI(id) {
  return http({
    url: "/admin/store/comboLink/list",
    method: "post",
    data: { id },
  });
}
export function downloadFile(pdfUrl, name) {
  axios({
    url: pdfUrl,
    method: "GET",
    responseType: "blob", // 必须指定为blob类型才能下载
  }).then((res) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${name}.png`);
    document.body.appendChild(link);
    link.click();
  });
}
// 导出
export function exportAPI(data) {
  showScreenLoading();
  axios({
    method: "post",
    url: "/api/admin/store/export",
    responseType: "blob",
    data,
    headers: {
      Authorization: getToken() || "",
    },
  })
    .then(async (res) => {
      hideScreenLoading();
      let data = res.data;
      let url = window.URL.createObjectURL(new Blob([data]));
      let a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      let filename = `OK租机门店列表${dateFormat()}.xlsx`;
      a.setAttribute("download", decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click(); //执行下载
      window.URL.revokeObjectURL(a.href); //释放url
      document.body.removeChild(a); //释放标签
    })
    .catch((error) => {
      hideScreenLoading();
      console.log(error);
    });
}

export function editStoreGrade(data) {
  return http({
    url: "/admin/store/grade/edit",
    method: "post",
    data,
  });
}
// 大区分区级联筛选项
export function getTopAreaCascadeAPI() {
  return http({
    url: "/admin/store/topArea/cascade",
    method: "get",
  });
}
/**
 * 新增跟进记录
 * @param {{ storeCode: string, followContent: string, imageList: string[] }} data
 * @param {string} data.storeCode - 门店标识
 * @param {string} data.followContent - 跟进记录内容
 * @param {string[]} data.imageList - 图片列表
 * @returns {Promise<boolean>}
 */
export function addFollowRecordAPI(data) {
  return http({
    url: "/admin/store/followRecord/add",
    method: "post",
    data,
  });
}

/**
 * 跟进记录列表
 * @param {{ storeCode?: string, page?: number, pageSize?: number }} params
 * @param {string} [params.storeCode] - 门店标识
 * @param {number} [params.page] - 页码
 * @param {number} [params.pageSize] - 每页条数
 * @returns {Promise<{
 *   page: number,
 *   pageSize: number,
 *   total: number,
 *   totalPage: number,
 *   storeCode: string,
 *   storeName: string,
 *   list: Array<{
 *     id: number,
 *     followUserId: number,
 *     followUserName: string,
 *     followContent: string,
 *     imageList: string[],
 *     followTime: string
 *   }>
 * }>}
 */
export function getFollowRecordPageAPI(params) {
  return http({
    url: "/admin/store/followRecord/page",
    method: "get",
    params,
  });
}

// 方案模板列表
export function getComboTemplatePageAPI(params) {
  return http({
    url: "/admin/store/combo/tpl/page",
    method: "get",
    params,
  });
}

// 批量关联门店方案模板
export function bindStoreTemplateAPI(data) {
  return http({
    url: "/admin/store/tpl/batch/edit",
    method: "post",
    data,
  });
}

// 配置门店商品价格模板（单个）
export function bindStoreGoodsPriceTplAPI(data) {
  return http({
    url: "/admin/store/goodsPriceTpl/bind",
    method: "post",
    data,
  });
}

// 批量配置门店商品价格模板
export function batchBindStoreGoodsPriceTplAPI(data) {
  return http({
    url: "/admin/store/goodsPriceTpl/batch/bind",
    method: "post",
    data,
  });
}

// 编辑门店成单奖励比例
export function editStoreDealRewardRateAPI(data) {
  return http({
    url: "/admin/store/dealRewardRate/edit",
    method: "post",
    data,
  });
}

// 导入门店成单奖励比例
export function importStoreDealRewardRateAPI(data) {
  return http({
    url: "/admin/store/dealRewardRate/import",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

/** 门店列表-新增联营合作 */
export function addStoreJointCooperationAPI(data) {
  return http({
    url: "/admin/store/joint/add",
    method: "post",
    data,
  });
}

/** 门店列表-撤销联营邀约 */
export function withdrawJointInviteAPI(data) {
  return http({
    url: "/admin/store/joint/invite/withdraw",
    method: "post",
    data,
  });
}

